















































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import STable from './STable.vue';
import mergeWith from 'lodash/mergeWith';
import { isArray } from 'lodash';

type Query = any; // eslint-disable-line @typescript-eslint/no-explicit-any
type QueryResults = any; // eslint-disable-line @typescript-eslint/no-explicit-any
type Variables = any; // eslint-disable-line @typescript-eslint/no-explicit-any
type Filters = { [filterName: string]: string };

@Component({
  i18n: {
    messages: {
      en: {
        errorOcurred: 'Error occurred. Please try again in few minutes, or contact support.',
      },
      nb: {
        errorOcurred: 'En feil har skjedd. Prøv igjen om noen minutter, eventuelt ta kontakt med support.',
      },
    },
  },
})
export default class SApolloTable<Item> extends Vue {
  @Ref() private apolloQuery!: Vue; // Vue component
  @Ref() private sTable!: STable<Item>;
  @Prop({ type: Object, required: true }) private query!: Query;
  @Prop([ Object, Function ]) private variables?: Variables | (() => Variables);
  @Prop(String) private fetchPolicy?: string;
  @Prop(Number) private debounce?: number;
  @Prop({ type: Function, required: true }) private dataGetter!: ((data: QueryResults) => Item[]);
  @Prop(Function) private errorHandler?: (err: string) => void;

  private emptyArray = [];

  private filters: Filters = {};
  private sortName = '';
  private sortDirection = '';

  private mounted(): void {
    this.initSort();
  }

  private get getVariables(): Variables {
    return typeof this.variables === 'function'
      ? this.variables({
        perPage: this.perPage,
        sortName: this.sortName,
        sortDirection: this.sortDirection,
        filters: this.filters,
      })
      : this.variables;
  }

  private updateFilter(filters: Filters): void {
    this.filters = filters;
    this.resetResult();
  }

  private initSort(): void {
    this.sortName = this.sTable.sortName;
    this.sortDirection = this.sTable.sortDirection;
  }

  private updateSort(field: string, direction: string): void {
    this.sortName = field;
    this.sortDirection = direction;
    this.resetResult();
  }

  // INFINITE SCROLL

  @Prop(Boolean) private infiniteScroll?: boolean;
  @Prop({ type: String, default: 'offset' }) private offsetVariableKey!: string;
  @Prop({ type: Number, default: 100 }) private perPage!: number;
  private isLoadingMore = false;
  private allLoaded = false;

  private resetResult(): void {
    this.allLoaded = false;
  }

  private fetchMore(data: Item[], query: Query): void {
    if (this.isLoadingMore) return;
    if (data.length < this.perPage) this.allLoaded = true;
    if (this.allLoaded) return;

    this.isLoadingMore = true;

    query.fetchMore({
      variables: { [this.offsetVariableKey]: data.length },
      updateQuery: (prev: QueryResults, { fetchMoreResult }: { fetchMoreResult: QueryResults }) => {
        if (!fetchMoreResult || this.dataGetter(fetchMoreResult).length < this.perPage) {
          this.allLoaded = true;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return mergeWith({}, prev, fetchMoreResult, (objValue: any, srcValue: any) => {
          if (isArray(objValue) && isArray(srcValue)) {
            return [ ...objValue, ...srcValue ];
          }
        });
      },
    }).finally(() => {
      this.isLoadingMore = false;
    });
  }

  public refetch(): void {
    this.resetResult();
    this.apolloQuery.$apollo.queries.query.refetch();
  }
}
